<template>
    <div
        v-if="results"
        class="searchSuggestions"
    >
        <ul class="searchSuggestions__list">
            <li
                v-for="result in results.slice(0, 7)"
                :key="result"
                class="searchSuggestions__listItem"
            >
                <a
                    class="searchSuggestions__link"
                    :href="`/search?keyword=${encodeURIComponent(result)}`"
                    @click.stop
                >
                    <i class="fal fa-search searchSuggestions__icon" />
                    {{ result }}</a>
            </li>
        </ul>
    </div>
    <!-- /.searchSuggestions -->
</template>

<script>
export default {
    name: 'SearchSuggestions',
    data() {
        return {
            results: [],
        };
    },
    created() {
        if (!this.results.length) {
            this.getSearches();
        }
    },
    methods: {
        getSearches() {
            axios.get('api/search/suggestions')
                .then((response) => {
                    this.results = response.data.data;
                });
        },
    },
};
</script>
